// extracted by mini-css-extract-plugin
module.exports = {"paddingForShadowDiv":"MediaCardGrid_paddingForShadowDiv__M9Gmr"};